<template>
  <main-layout>
    <baseModal
      id="initialQuestions"
      :show="true"
      :size="calculatedSize"
    >
      <video-player
        ref="videoPlayer"
        class="video-player-box"
        :options="playerOptions"
        @ended="goToQuestions"
        @timeupdate="onPlayerTimeupdate($event)"
      />
      <template slot="footer">
        <span
          v-if="!can_continue"
        >Podrás saltar el video en {{ timeLeft }}
          {{ (timeLeft == 1)? 'segundo': 'segundos' }}</span>
        <base-button
          v-if="can_continue"
          inverse
          @click="goToQuestions"
        >
          Saltar video
        </base-button>
      </template>
    </baseModal>
  </main-layout>
</template>

<script>
/* eslint-disable import/no-extraneous-dependencies */
import 'video.js/dist/video-js.css';
import { videoPlayer } from 'vue-video-player';

export default {
    name: 'Video',
    components: {
        videoPlayer,
    },
    data() {
        return {
            can_continue: false,
            currentTime: 0,
            playerOptions: {
                fluid: true,
                controls: true,
                autoplay: true,
                sources: [
                    {
                        type: 'video/mp4',
                        src: 'vid/video_inicial.mp4',
                    },
                ],
            },
        };
    },
    computed: {
        timeLeft() {
            return (11 - this.currentTime).toFixed();
        },
        calculatedSize() {
            const height = window.innerHeight;
            if (height > 700) {
                return 'modal-xl';
            }
            return 'modal-lg';
        },
    },
    mounted() {
        this.$nextTick(function () {
            this.$store.commit('authentication/checkedVideo');
        });
    },
    methods: {
        goToQuestions() {
            this.$store.commit('authentication/seenVideo');
            this.$router.push({ name: 'regions', params: this.$route.params });
        },
        onPlayerTimeupdate(player) {
            this.currentTime = player.currentTime();
            if (player.currentTime() >= 10) {
                this.can_continue = true;
            }
        },
    },
};
</script>
